/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Anticipation_In_ProgressInputs */



/**
* | output |
* | --- |
* | "Anticipation in progress" |
*
* @param {Anticipation_In_ProgressInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const anticipation_in_progress = /** @type {((inputs?: Anticipation_In_ProgressInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Anticipation_In_ProgressInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Anticipation in progress")
	return /** @type {LocalizedString} */ ("Anticipation en cours")
});